import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CookieModule, CookieOptionsProvider, CookieService, COOKIE_OPTIONS } from 'ngx-cookie';
import { AnsokanHomeComponent } from './ansokan-home/ansokan-home.component';
import { NavigationQueryComponent } from './ansokan-home/navigation-query/navigation-query.component';
import { AnsokanComponent } from './ansokan/ansokan.component';
import { AttachmentComponent } from './ansokan/pages/attachment/attachment.component';
import { ConfirmationComponent } from './ansokan/pages/confirmation/confirmation.component';
import { ContactInfoComponent } from './ansokan/pages/contact-info/contact-info.component';
import { DegreeComponent } from './ansokan/pages/degree/degree.component';
import { ExaminaComponent } from './ansokan/pages/degree/examina/examina.component';
import { OtherQualificationComponent } from './ansokan/pages/other-qualification/other-qualification.component';
import { ReviewComponent } from './ansokan/pages/review/review.component';
import { SpecialEducationComponent } from './ansokan/pages/special-education/special-education.component';
import { StartComponent } from './ansokan/pages/start/start.component';
import { VocationalQualificationComponent } from './ansokan/pages/vocational-qualification/vocational-qualification.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AreaComponent } from './components/area/area.component';
import { AttachmentSelectorComponent } from './components/attachment-selector/attachment-selector.component';
import { BannerComponent } from './components/banner/banner.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { FooterComponent } from './components/footer/footer.component';
import { FormGroupComponent } from './components/form-group/form-group.component';
import { HeaderComponent } from './components/header/header.component';
import { InputComponent } from './components/input/input.component';
import { LinkComponent } from './components/link/link.component';
import { ModalComponent } from './components/modal/modal.component';
import { NavigationBarComponent } from './components/navigation-bar/navigation-bar.component';
import { QualificationBasisComponent } from './components/qualifications/qualification-basis/qualification-basis.component';
import { QualificationsComponent } from './components/qualifications/qualifications.component';
import { ViewQualificationsComponent } from './components/qualifications/view-qualifications/view-qualifications.component';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';
import { RevealComponent } from './components/reveal/reveal.component';
import { SelectComponent } from './components/select/select.component';
import { TableComponent } from './components/table/table.component';
import { LoggedInComponent } from './logged-in/logged-in.component';
import { MaterialModule } from './material.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { AnsokanFormBuilderService } from './service/ansokan-form-builder/ansokan-form-builder.service';
import { AnsokanFormGroupService } from './service/ansokan-form-group/ansokan-form-group.service';
import { TokenInterceptor } from './service/auth/token-interceptor';
import { OrientationRepositoryService } from './service/qualification/orientation-repository.service';
import { QualificationRepositoryService } from './service/qualification/qualification-repository.service';
import { SyllabusService } from './service/syllabus/syllabus.service';
import { SupplementComponent } from './supplement/supplement.component';

@NgModule({ bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        AnsokanHomeComponent,
        NavigationQueryComponent,
        LinkComponent,
        AnsokanComponent,
        NotFoundComponent,
        NavigationBarComponent,
        ContactInfoComponent,
        DegreeComponent,
        InputComponent,
        FormGroupComponent,
        ReviewComponent,
        StartComponent,
        SelectComponent,
        CheckboxComponent,
        ExaminaComponent,
        AttachmentSelectorComponent,
        VocationalQualificationComponent,
        OtherQualificationComponent,
        SpecialEducationComponent,
        RadioButtonComponent,
        QualificationsComponent,
        QualificationBasisComponent,
        ViewQualificationsComponent,
        TableComponent,
        ModalComponent,
        AttachmentComponent,
        BannerComponent,
        RevealComponent,
        ConfirmationComponent,
        SupplementComponent,
        AreaComponent,
        LoggedInComponent
    ], imports: [AppRoutingModule,
        BrowserModule,
        MaterialModule,
        ReactiveFormsModule,
        CookieModule.withOptions()], providers: [
        AnsokanFormBuilderService,
        AnsokanFormGroupService,
        QualificationRepositoryService,
        SyllabusService,
        OrientationRepositoryService,
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }

declare global{
  interface Navigator{
     msSaveOrOpenBlob:(blob: Blob,fileName:string) => boolean
     }
  }